import React, { FunctionComponent } from 'react'
import GatsbyImage from 'gatsby-image'
import { has } from 'lodash'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'

import { RTFBlockComponentProps, RTFBlockComponentExport } from '../../types'

import { contentfulAsset } from './index.module.scss'

export type RTFContentfulAssetGraphQLResult = {
  __typename: EF.RTFBlockTypename.ContentfulAsset
  file: { url: string }
} & ContentfulRichTextGatsbyReference &
  (EF.FluidImageNode | EF.FixedImageNode)

export type ContentfulAssetBlockProps = RTFBlockComponentProps &
  (EF.FluidImageNode | EF.FixedImageNode)

const ContentfulAssetBlock: FunctionComponent<ContentfulAssetBlockProps> = ({
  title,
  fields: { asset: imgProps },
}) => {
  return (
    <div className={contentfulAsset}>
      <GatsbyImage alt={title} {...imgProps} />
    </div>
  )
}

const componentExport: RTFBlockComponentExport = {
  component: ContentfulAssetBlock,
  isValid: (props) =>
    has(props, 'fields.asset.fixed') || has(props, 'fields.asset.fluid'),
}

export default componentExport
